


import { Component } from "vue-property-decorator";
import { runAus } from "@/models/tasks.model";
import AddComment from "@/views/AddComment.vue";
import Axios from "axios";
import {mixins} from "vue-class-component";
import { BASE_API_URL,EventBus } from "../../../../config";
import { ALLOWED_FILE_EXTENSIONS } from "@/constants";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import RunausRequest from "@/components/urla/los/order-service/runaus-request/RunausRequest.vue";
import { Borrower } from "@/models/order-service.model";
import _ from "lodash";
import saveAs from "save-as";
import print from 'print-js'
import RunAusMixin from "@/mixins/RunAusMixin.mixin";
import PipeLineSocketMixin from "@/mixins/PipeLineSocketMixin"
import CommonMixin from "@/mixins/common.mixin";


@Component({
  components: {
    AddComment,
    PDFViewer,
    RunausRequest,
  }
})
export default class RunAusComponent extends mixins(RunAusMixin, PipeLineSocketMixin, CommonMixin) {
  public allowedFileExtensions = ALLOWED_FILE_EXTENSIONS;
  public loanTxnId = null;
  public runAusData = new runAus();
  public pipeLineHeaderData: any = {};
  public ausFindings = null;
  public creditVendors = [];
  public borrowers: Array<Borrower> = new Array<Borrower>();
  public creditReportStatus = null;
  public ausCasefileId = null;
  public isFHAOrVA = false;
  public isMismo: boolean = null;
  public lastSuccessfulFinding = null;
  public mostUsedCreditAgenciesIds: any = [];
  public vendorsCredentials: any = [];
  public taskNameForRoom = 'run-aus';
  
  get ausRecommendation() {
    return _.get(this.ausFindings, 'recommendation', null);
  }

  get ausKey() {
    return _.get(this.ausFindings, '_id', '');
  }

  get ausErrorMessages() {
    return _.get(this.ausFindings, 'responseDetails.findingErrors', [])
      .map(error => {return {'message': _.get(error, 'message', false), 'type': error.type}})
      .filter(error => error.message);
  }

  private playWeLearnVideo() {
    EventBus.$emit("openWeLearn", { taskName: "Run Aus", videoUrl: 'https://wemlo.s3.amazonaws.com/Common/taskdemo/RUNAUS.mp4' });
  }

  public async submit(ifSave) {
    try {
      /**
       * Validating all fields here
       */
      ifSave = ifSave == "Save" ? true : false;

      let validComment = await this.$refs.comment["validateComment"](ifSave);
      if (
        ifSave
          ? false
          : !(await this.$validator.validateAll()) || !validComment
      )
        return;

      this.$store.state.wemloLoader = true;
      let formData = new FormData();

      formData.append("loanTxnId", this.loanTxnId);
      /**
       * Appending comment data and comment attachments here in formdata
       */
      let commentObj: any = {
        comment: this.runAusData.commentData.comment,
        showCommentToBroker: this.runAusData.commentData.showCommentToBroker
      };
      if (
        this.runAusData.commentData.commentAttachment.length > 0 &&
        !this.runAusData.commentData.commentAttachment[0].hasOwnProperty("path")
      )
        this.runAusData.commentData.commentAttachment.forEach(file => {
          formData.append("commentAttachment", file);
        });
      else if (this.runAusData.commentData.commentAttachment.length > 0)
        commentObj.commentAttachment = this.runAusData.commentData.commentAttachment;
      formData.append("commentData", JSON.stringify(commentObj));

       /**
       * Appending lender disclosure document data here in formdata
       */
      if (
        this.runAusData.copyOfDUOrLPFindings &&
        !this.runAusData.copyOfDUOrLPFindings.hasOwnProperty("path")
      )
        this.runAusData.copyOfDUOrLPFindings.forEach(file => {
          formData.append("copyOfDUOrLPFindingsDocument", file);
        });
      /**
       * Merging the save or complete option here
       */
      formData.append("options", JSON.stringify(this.runAusData.options));
      formData.append("ausOption", JSON.stringify(this.runAusData.ausOption || null));
      if (this.runAusData.loanNumber) {
        formData.append("loanNumber", this.runAusData.loanNumber);
      }

      formData.append("ifSave", ifSave);

      /**
       * Finally sending request to server with formdata in body
       */

      let response = await Axios.post(
        BASE_API_URL + "wemloprocessor/runAus",
        formData);
      this.$snotify[
        response.data.status == 200
          ? "success"
          : response.status == 403
          ? "info"
          : "error"
      ](response.data.message);

      if (response.data.status == 200) {
        this.saveEvent();
      }

      EventBus.$emit('closeWeLearn',false); // Closing learn more video modal;

      if (!ifSave) {
        this.$router.push({ path: "dashboard" });
      }
    } catch (error) {
      console.log(error);
      const infectedFiles = this.checkResponseIfFileInfected(error);
      infectedFiles.forEach(filename => {
        this.removeInfectedFile(filename)
      })
    } finally {
      this.$store.state.wemloLoader = false;
    }
  }
  public removeInfectedFile(filename: string): void {
    // check if comment attachment contains infected filename
    if (
      this.runAusData.commentData.commentAttachment.length > 0 &&
      !this.runAusData.commentData.commentAttachment[0].hasOwnProperty(
        "path"
      )
    )
    {
      this.runAusData.commentData.commentAttachment = this.runAusData.commentData.commentAttachment.filter(file => (file.name !== filename));
    }
    // check if copyOfDUOrLPFindings contains infected filename
    if (
      this.runAusData.copyOfDUOrLPFindings &&
      !this.runAusData.copyOfDUOrLPFindings.hasOwnProperty("path")
    ) {

        this.runAusData.copyOfDUOrLPFindings = this.runAusData.copyOfDUOrLPFindings.filter(file => (file.name !== filename));
    }
  }

  async uploadFile(event) {
    if (event.target.files.length > 0) {
      Object.values(event.target.files).forEach(element => {
          this.runAusData.copyOfDUOrLPFindings.push(element);
      });
    }
  }

  public displayUploadFiles(file, viewFileName) {
    this.$refs.comment["displayCommentAttachment"](file, true, viewFileName);
  }

  async fetchRunAusTaskDetail() {
    try {
      this.$store.state.wemloLoader = true;
      let response = await Axios.post(
        BASE_API_URL + "wemloprocessor/fetchRunAusTaskDetail",
        { loanTxnId: this.loanTxnId });
      this.runAusData = response.data.runAusData;
      this.pipeLineHeaderData = response.data.pipelineHeader;
      this.$store.state.wemloLoader = false;
    } catch (error) {
      this.$store.state.wemloLoader = false;
      console.log(error);
    }
  }

  async beforeMount() {
    this.loanTxnId = this.$route.query.id;
    await this.fetchRunAusTaskDetail();
  }

  async getEnumerationType() {
    const { data: { enumerationType } } = await Axios.post(
      BASE_API_URL + 'los/getEnumerationType',
      { loanTxnId: this.$route.query.id, }
    );

    return enumerationType;
  }

  async saveAusFile(action) {
    if (!this.ausFilepath) return;

    this.$store.state.wemloLoader = true;

    try {
      const { data: fileObject } = await Axios.post(
        BASE_API_URL + 'common/downloadPDF',
        { data: this.ausFilepath },
        { responseType: "blob" }
      );
      const fileName =  _.last(_.split(this.ausFilepath, '/'));

      if (action === 'download') {
        saveAs(fileObject, fileName);
      } else if (action === 'print') {
        const url = URL.createObjectURL(fileObject);
        print(url);
      }
    } catch (error) {}

    this.$store.state.wemloLoader = false;
  }

  async mounted() {
    this.isMismo = (await this.getEnumerationType()) === 'mismo';

    await this.getCreditVendors();
    await this.getAusFindings();
  }
}
